import { setCookie } from 'cookies-next'
import { waitForNavigation } from '@captaincause/lib/waitForNavigation'
import { SERVER_USER_TOKEN_COOKIE } from 'constants/cookies'
import type { RegisteredUser } from 'types/user'

export function useSignIn() {
  return async (
    registeredUser: Partial<RegisteredUser> | undefined,
    redirectUrl = '/me/profile',
  ) => {
    if (registeredUser && registeredUser.token) {
      setCookie(SERVER_USER_TOKEN_COOKIE, registeredUser.token.token, {
        expires: new Date(registeredUser.token.expires_at),
        secure: true,
        sameSite: 'lax',
      })

      await waitForNavigation(redirectUrl)
    }
  }
}
